var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdxpc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.77426+30.5804C8.77426+29.7848+10.0086+29.1398+11.5312+29.1398C13.0539+29.1398+14.2882+29.7848+14.2882+30.5804C14.2882+31.376+13.0539+32.021+11.5312+32.021C10.0086+32.021+8.77426+31.376+8.77426+30.5804Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3636+25.0024C17.3636+24.2562+18.5213+23.6512+19.9495+23.6512C21.3776+23.6512+22.5353+24.2562+22.5353+25.0024C22.5353+25.7486+21.3776+26.3536+19.9495+26.3536C18.5213+26.3536+17.3636+25.7486+17.3636+25.0024Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.765+19.6503C28.765+18.9063+29.9192+18.3033+31.3429+18.3033C32.7666+18.3033+33.9208+18.9063+33.9208+19.6503C33.9208+20.3942+32.7666+20.9973+31.3429+20.9973C29.9192+20.9973+28.765+20.3942+28.765+19.6503Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5399+37.5581C17.5399+36.7416+18.8067+36.0797+20.3693+36.0797C21.9319+36.0797+23.1987+36.7416+23.1987+37.5581C23.1987+38.3746+21.9319+39.0365+20.3693+39.0365C18.8067+39.0365+17.5399+38.3746+17.5399+37.5581Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2167+30.6514C28.2167+29.8768+29.4185+29.2488+30.9009+29.2488C32.3834+29.2488+33.5851+29.8768+33.5851+30.6514C33.5851+31.426+32.3834+32.0539+30.9009+32.0539C29.4185+32.0539+28.2167+31.426+28.2167+30.6514Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8278+23.9821C38.8278+23.2225+40.0062+22.6067+41.46+22.6067C42.9137+22.6067+44.0922+23.2225+44.0922+23.9821C44.0922+24.7417+42.9137+25.3575+41.46+25.3575C40.0062+25.3575+38.8278+24.7417+38.8278+23.9821Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6369+43.8704C27.6369+42.9493+29.0659+42.2026+30.8287+42.2026C32.5915+42.2026+34.0206+42.9493+34.0206+43.8704C34.0206+44.7915+32.5915+45.5382+30.8287+45.5382C29.0659+45.5382+27.6369+44.7915+27.6369+43.8704Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7293+37.3569C38.7293+36.4962+40.0646+35.7985+41.7118+35.7985C43.359+35.7985+44.6943+36.4962+44.6943+37.3569C44.6943+38.2176+43.359+38.9153+41.7118+38.9153C40.0646+38.9153+38.7293+38.2176+38.7293+37.3569Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6926+30.949C48.6926+30.1758+49.8922+29.549+51.3719+29.549C52.8516+29.549+54.0511+30.1758+54.0511+30.949C54.0511+31.7221+52.8516+32.3489+51.3719+32.3489C49.8922+32.3489+48.6926+31.7221+48.6926+30.949Z",
    opacity: 1,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdxpc);
export default __webpack_public_path__ + "static/media/idxpc.d19fb38333caaab88ff766d09e531f9d.svg";
export { ForwardRef as ReactComponent };